import BurgerContent from "../components/burger-content/BurgerContent";
import "../global/global.css";

const HomePage = () => {
  return <BurgerContent title={"Соберите бургер"} />;
};

export default HomePage;
